<template>
    <div>
        <div>
            <div v-if="statusOne">
                <span
                    v-html="$t('notification.customerOwnershipRemoved',{actor:$_.get(activity, 'actorUser.name'),visitor:$_.get(activity, 'payload.visitorName'),oldOwner:$_.get(activity, 'payload.oldOwnerName')})"></span>
            </div>
            <div v-else-if="statusTwo">
                <span
                    v-html="$t('notification.customerOwnershipAssigned',{actor:$_.get(activity, 'actorUser.name'),visitor:$_.get(activity, 'payload.visitorName'),newOwner:$_.get(activity, 'payload.ownerName')})"></span>
            </div>
            <div v-else-if="statusThree">
                <span
                    v-html="$t('notification.customerOwnershipReassigned',{actor:$_.get(activity, 'actorUser.name'),visitor:$_.get(activity, 'payload.visitorName'),oldOwner:$_.get(activity, 'payload.oldOwnerName'),newOwner:$_.get(activity, 'payload.ownerName')})"></span>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "ChatOwnerUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            statusOne: false,
            statusTwo: false,
            statusThree: false,
        };
    },
    methods: {
        toggleStatus() {
            if (_.get(this.activity, "payload.ownerName") === null) {
                this.statusOne = true;
            } else if (_.get(this.activity, "payload.oldOwnerName") === null) {
                this.statusTwo = true;
            } else if (_.get(this.activity, "payload.ownerName") !== null && _.get(this.activity, "payload.oldOwnerName") !== null) {
                this.statusThree = true;
            }
        },
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
    mounted() {
        this.toggleStatus();
    },
});
</script>

<style scoped lang="scss"></style>
